import React from "react";

import { AdministrationCard } from "@common/components/AdministrationCard/AdministrationCard";
import { ToggleSection } from "@common/components/ToggleSection/ToggleSection";

interface SheldonCardProps {
  isSheldonEnabled: boolean;
  setSheldonEnabled: (enabled: boolean) => void;
  loading?: boolean;
  saving?: boolean;
}

export default function SheldonCard({ isSheldonEnabled, setSheldonEnabled, loading, saving }: SheldonCardProps) {
  return (
    <AdministrationCard title="Sheldon the AI assistant">
      <ToggleSection
        onChange={setSheldonEnabled}
        disabled={loading || saving}
        title="Active"
        subtitle="When active, Sheldon can summarize tickets and flag unusual activity history logs."
        checked={isSheldonEnabled}
      />
    </AdministrationCard>
  );
}
